<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>关卡名称配置</span>
          <el-row :gutter="12" class="mb8" style="margin-top: 20px;">
            <el-col :span="1.5">
              <el-upload
                ref="upload"
                class="upload-demo"
                :action="sys_app_logoAction"
                accept="xlsx"
                :limit="1"
                :on-success="importUploadSuccess"
                :headers="headers"
              >
                <el-button v-permisaction="['config:levelName:import']" :loading="loading" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
              </el-upload>
            </el-col>

            <el-col :span="1.5">
              <el-button
                v-permisaction="['config:levelName:export']"
                type="primary"
                icon="el-icon-download"
                size="mini"
                @click="exportData"
              >导出</el-button>
            </el-col>
            <el-col :span="1.5">
              <el-button v-permisaction="['config:levelName:uploadCdn']" :loading="loading" size="mini" type="primary" @click="uploadCdn()">同步到S3</el-button>
            </el-col>
          </el-row>
        </div>

        <el-table :data="formData" border stripe>
          <el-table-column prop="levelId" label="关卡ID" width="150px">
            <template slot-scope="scope">
              <el-input v-model.number="scope.row.levelId" placeholder="关卡ID" style="width: 120px" />
            </template>
          </el-table-column>
          <el-table-column prop="content" label="中文">
            <template slot-scope="scope">
              <!--              <el-input v-model="scope.row.lang[0].content" placeholder="关卡ID" />-->
              <span>{{ scope.row.lang[1].content }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="content" label="英语">
            <template slot-scope="scope">
              <!--              <el-input v-model="scope.row.lang[1].content" placeholder="关卡ID" />-->
              <span>{{ scope.row.lang[0].content }}</span>
            </template>
          </el-table-column>
          <el-table-column label="语言配置">
            <template slot-scope="scope">
              <el-button type="primary" style="margin-left: 16px;" @click="drawerArr[scope.$index].visible = true">
                查看更多
              </el-button>

              <el-drawer
                title="语言配置"
                :visible.sync="drawerArr[scope.$index].visible"
                direction="rtl"
                size="650px"
                :before-close="(d)=>handleClose(d, scope.$index)"
              >
                <el-form :inline="true" label-width="100px">
                  <el-row v-for="(pp,pi) in scope.row.lang" :key="pi">
                    <el-form-item :label="lang[pp.lang]" style="margin-top: 10px;">
                      <el-input v-model="pp.content" style="width: 420px;" :placeholder="lang[pp.lang]" />
                    </el-form-item>
                  </el-row>
                </el-form></el-drawer>
            </template>
          </el-table-column>
          <!--          <el-table-column label="操作">-->
          <!--            <template slot-scope="scope">-->
          <!--              <el-button v-permisaction="['config:levelName:del']" type="danger" @click="del(scope.row.id)">删除</el-button>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
        </el-table>
        <el-button v-permisaction="['config:levelName:add']" type="primary" style="margin-top: 10px" @click="add()">+</el-button>
        <el-button v-permisaction="['config:levelName:add']" type="primary" style="margin-top: 10px" @click="onSubmit()">保存</el-button>
        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>

    </template>
  </BasicLayout>
</template>

<script>
import {
  delLangLevelCfg,
  exportLangLevelCfg,
  getLangLevelCfg,
  importLangLevelCfg,
  updateLangLevelCfg, uploadLangLevelCdn
} from '@/api/config/lang-level-cfg'
import { getToken } from '@/utils/auth'
export default {
  name: 'LevelNameConfig',
  data() {
    return {
      loading: false,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      drawerArr: [{ visible: false }],
      shopSku: [],
      rewardType: [],
      statusType: [{ label: '上架', value: 1 }, { label: '下架', value: 0 }],
      total: 0,
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        type: this.gType
      },
      gType: 109,
      lang: {
        'en': '英 文',
        'zh': '中 文',
        'tw': '繁 体',
        'fr': '法 语',
        'de': '德 语',
        'es': '西班牙',
        'pt': '葡萄牙',
        'th': '泰 语',
        'vn': '越 南',
        'no': '挪 威',
        'id': '印 尼',
        'rou': '罗马尼亚',
        'my': '马来语',
        'ita': '意大利',
        'ph': '波兰'
      },
      formData: [
        {
          'levelId': 0,
          'lang': [
            { 'lang': 'en', 'content': '' },
            { 'lang': 'zh', 'content': '' },
            { 'lang': 'de', 'content': '' },
            { 'lang': 'fr', 'content': '' },
            { 'lang': 'id', 'content': '' },
            { 'lang': 'no', 'content': '' },
            { 'lang': 'rou', 'content': '' },
            { 'lang': 'tw', 'content': '' },
            { 'lang': 'vn', 'content': '' },
            { 'lang': 'th', 'content': '' },
            { 'lang': 'my', 'content': '' },
            { 'lang': 'ita', 'content': '' },
            { 'lang': 'es', 'content': '' },
            { 'lang': 'pt', 'content': '' },
            { 'lang': 'ph', 'content': '' }
          ]
        }
      ]
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    handleClose(done, index) {
      this.drawerArr[index].visible = false
    },
    priceChange(v, index) {
      let sku = ''
      for (const i in this.shopSku) {
        const val = this.shopSku[i]
        if (val.value === v) {
          sku = val.sku
          break
        }
      }

      if (!sku) {
        this.msgError('sku有误')
        return
      }

      this.formData[index].sku = sku
    },
    onSubmit() {
      const data = JSON.stringify(this.formData)
      console.log(data)
      updateLangLevelCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getLangLevelCfg(this.queryParams).then(res => {
        if (res.code === 200) {
          res.data.list.forEach((item) => {
            this.drawerArr.push({ visible: false })
          })
          this.formData = res.data.list
          this.total = res.data.count
        } else {
          this.msgError(res.msg)
        }
      })
    },
    add() {
      this.formData.push({
        id: 0,
        'levelId': 0,
        'lang': [
          { 'lang': 'en', 'content': '' },
          { 'lang': 'zh', 'content': '' },
          { 'lang': 'de', 'content': '' },
          { 'lang': 'fr', 'content': '' },
          { 'lang': 'id', 'content': '' },
          { 'lang': 'no', 'content': '' },
          { 'lang': 'rou', 'content': '' },
          { 'lang': 'tw', 'content': '' },
          { 'lang': 'vn', 'content': '' },
          { 'lang': 'th', 'content': '' },
          { 'lang': 'my', 'content': '' },
          { 'lang': 'ita', 'content': '' },
          { 'lang': 'es', 'content': '' },
          { 'lang': 'pt', 'content': '' },
          { 'lang': 'ph', 'content': '' }
        ]
      })
      this.drawerArr.push({ visible: false })
    },
    del(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delLangLevelCfg({ id: id }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables()
          } else {
            this.msgError(res.msg)
          }
        })
      })
    },
    importUploadSuccess(response, file, fileList) {
      this.loading = true
      this.$refs.upload.clearFiles()
      importLangLevelCfg({ data: response.data.path }).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    }, exportData() {
      exportLangLevelCfg().then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    }, uploadCdn() {
      this.$confirm('请检查数据是否有误，该操作将同步到S3最新版本?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '再看看',
        type: 'warning'
      }).then(() => {
        uploadLangLevelCdn({ name: this.name, type: this.key }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables(name)
          } else {
            this.msgError(res.msg)
          }
        })
      })
    }
  }
}
</script>

<style scoped>
</style>
